import React from 'react';
import useUtilizationPerMonthPerYearTotalChart from './hooks/useUtilizationPerMonthPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerMonthPerYearTotal = ({ height = 400 }) => {
    const { series, subtitles } = useUtilizationPerMonthPerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Soma da Utilização Mensal no Ano Selecionado`}
        />
    );
};
